import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'protocols-coverage-tags-input',
  standalone: true,
  imports: [MatIcon, TranslatePipe],
  templateUrl: './coverage-tags-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoverageTagsInputComponent {
  readonly tags = input.required<string[]>();
  readonly readonly = input<boolean>(false);
  readonly tagsChange = output<string[]>();

  protected readonly draft = signal('');

  protected addTag(): void {
    const value = this.draft().trim();
    if (!value) {
      return;
    }

    const current = this.tags();
    if (!current.includes(value)) {
      this.tagsChange.emit([...current, value]);
    }

    this.draft.set('');
  }

  protected removeTag(tag: string): void {
    this.tagsChange.emit(this.tags().filter(item => item !== tag));
  }

  protected onInput(event: Event): void {
    this.draft.set((event.target as HTMLInputElement).value);
  }
}
